import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi, { date } from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { PluckingChecklistBPLTeaReportSchema } from "../PluckingChecklistBPLTeaReportSchema";
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import '../../../Common/Table/table.css';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { InputAdornment, Box } from '@material-ui/core';
import Search from '@mui/icons-material/Search';
import _ from 'lodash';
import moment from 'moment';
import MessageModal from '../../../../UI/Modal/MessageModal';

const screenCode = 'PLUCKINGCHECKLISTBPLTEAREPORT'

export function PluckingChecklistBPLTeaReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [subNames, setSubNames] = useState([]);
    const [unitNames, setUnitNames] = useState([])
    const [colName, setColName] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "",
        operationEntityID: "",
        collectionPointID: "",
        pluckingType: "0",
        date: new Date().toISOString().split('T')[0],
        checklistID: "0"
    });
    const [customSearch, setCustomSearch] = useState({
        regNumber: ''
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: "",
        pluckingType: "",
        field: "",
        date: "",
        checklistID: "0"
    });
    const [summeryValues, setSummeryValues] = useState({
        full: 0,
        half: 0,
        bellow: 0,
        allTotal: 0,
        okTot: 0,
        totMan: 0,
        totMandays: 0
    });
    const [totalValues, setTotalValues] = useState({
        totalOverKg: 0,
        totalDay: 0
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(PluckingChecklistBPLTeaReportSchema).options({ allowUnknown: true });

    const [csvHeaders, setCsvHeaders] = useState([]);

    const [data, setdata] = useState([]);
    const [data1, setdata1] = useState([]);
    const [summeryData, setSummeryData] = useState([]);
    const [summaryUnits, setSummaryUnits] = useState([])
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2, "collectionPoint": 3, "date": 4, "pluckingType": 5 })
    const [checklist, setChecklist] = useState();
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });
    const [hideSearch, setHideSearch] = useState(true)

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        if (searchData.groupID != 0 || searchData.groupID != "") {
            trackPromise(
                getOperationEntities()
            )
        }
        resetDropDowns(DropdownChanges.group);
    }, [searchData.groupID])

    useEffect(() => {
        if (searchData.operationEntityID > 0) {
            trackPromise(
                getCollectionCategoryForDropDown()
            )
            getCollectionPointsForDropDown();
            resetDropDowns(DropdownChanges.operationEntity);
        } else {
            setCollectionPoint([]);
            resetDropDowns(DropdownChanges.operationEntity);
        }
    }, [searchData.operationEntityID])

    useEffect(() => {
        resetDropDowns(DropdownChanges.collectionPoint);
    }, [searchData.collectionPointID])

    useEffect(() => {
        resetDropDowns(DropdownChanges.date);
    }, [searchData.date])

    useEffect(() => {
        resetDropDowns(DropdownChanges.pluckingType);
    }, [searchData.pluckingType])

    useEffect(() => {
        handleSearch1(customSearch.regNumber);
    }, [customSearch.regNumber]);

    useEffect(() => {
        setChecklist([])
    }, [searchData.operationEntityID, searchData.collectionPointID]);

    useEffect(() => {
        trackPromise(getChecklistForDropdown());
    }, [searchData.date, searchData.pluckingType]);

    useEffect(() => {
        if (data.length != 0) {
            calculateTotal()
        }
    }, [data]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPLUCKINGCHECKLISTBPLTEAREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {
            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)
            setsearchData({
                ...searchData,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID,
                date: new Date().toISOString().split('T')[0]
            });

        } else {
            setsearchData({
                ...searchData,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID,
                date: new Date().toISOString().split('T')[0]
            });
        }
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID,
            date: new Date().toISOString().split('T')[0]
        });

        getGroupsForDropDown();
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.date) {
            setsearchData({
                ...searchData,
                checklistID: "0",
            });
        } else if (type === DropdownChanges.pluckingType) {
            setsearchData({
                ...searchData,
                checklistID: "0",
            });
        } else if (type === DropdownChanges.collectionPoint) {
            setsearchData({
                ...searchData,
                pluckingType: "0",
                checklistID: "0",
                date: new Date().toISOString().split('T')[0],
            });
        } else if (type === DropdownChanges.operationEntity) {
            setCollectionPoint([]);
            setsearchData({
                ...searchData,
                collectionPointID: "0",
                pluckingType: "0",
                checklistID: "0",
                date: new Date().toISOString().split('T')[0],
            });
        } else if (type === DropdownChanges.group) {
            setsearchData({
                ...searchData,
                operationEntityID: "0",
                collectionPointID: "0",
                pluckingType: "0",
                checklistID: "0",
                date: new Date().toISOString().split('T')[0],
            });
        }
    }

    async function getOperationEntities() {
        try {
            const data = await service.getEstatesByGroupID(searchData.groupID);
            const token = tokenService.getUserDetailsFromTokenV2();
            const validEstateIds = token.operationEntities.map(entity => String(entity.OperationEntityID));

            let estateList = [];
            if (Array.isArray(data) && data.every(item => typeof item === 'object' && item.id && item.name)) {
                estateList = data;
            } else {
                estateList = data
                    .map((name, index) => name ? { id: String(index), name } : null)
                    .filter(item => item !== null);
            }
            const filteredEstates = estateList.filter(operationEntity => validEstateIds.includes(String(operationEntity.id)));

            setOperationEntity(filteredEstates);
            setMultipleEstates(filteredEstates);
        } catch (error) {
            setOperationEntity([]);
            setMultipleEstates([]);
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: "Failed to load estates. Please try again.",
            });
            setTimeout(() => {
                setMessageModel(prev => ({ ...prev, hidden: true }));
            }, 4000);
        }
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    // async function getOperationEntities() {
    //     const operationEntityList = await service.getEstatesByGroupID(searchData.groupID);
    //     setOperationEntity(operationEntityList);
    // }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.operationEntityID);
        setCollectionCategory(collectionCategory);
    }

    async function getCollectionPointsForDropDown() {
        if (searchData.operationEntityID && searchData.operationEntityID !== "0") {
            const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(
                searchData.operationEntityID,
                searchData.groupID
            );
            setCollectionPoint(collectionPoint);
        } else {
            setCollectionPoint([]);
        }
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, PluckingChecklistBPLTeaReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
        clearTableRelatedData();
    }

    function handleChangeCheck(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, PluckingChecklistBPLTeaReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });
        setErrors(error);
        clearTableRelatedData();
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        let result = await service.getReportData(searchData.collectionPointID, searchData.pluckingType, searchData.date, searchData.checklistID);
        formatResult(result);
        getSelectedDropdownValuesForReport(searchData);
        if (result.length > 0) {
            setHideSearch(false)
        } else {
            setHideSearch(true)
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);

        }
    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        let totalOfUnits = 0
        var names = [];
        let unitNames = []
        var csvHeaders = [
            { label: "Reg Number", value: "registrationNumber" },
            { label: "Employee Name", value: "firstName" },
            { label: "Field", value: "fieldName" },
        ];
        data.forEach(x => {
            var sessionName = x.sessionName;
            var sessionForUnit = x.sessionName + 'UN'
            if (result.length === 0) {
                result.push({
                    [sessionForUnit]: checkUndifind(x.numberOfUnits),
                    [sessionName]: checkUndifind(x.totalAmount),
                    employeeID: parseInt(x.employeeID),
                    registrationNumber: x.registrationNumber,
                    firstName: x.firstName,
                    total: checkUndifind(x.totalAmount),
                    configurationValue: x.configurationValue,
                    fieldName: x.fieldName,
                    borrowedDivision: x.borrowedDivision,
                    maxValue: x.maxValue,
                    minValue: x.minValue,
                    isHolidayOrSunday: x.isHolidayOrSunday,
                    [sessionName + ' ReadTime']: x.cardReadTime,
                    mandays: x.mandays,
                    isAssigned: x.isAssigned,
                    assignAt: x.assignAt,

                });
                names.push(x.sessionName);
                unitNames.push(x.sessionName + 'UN')
                csvHeaders.push({ label: x.sessionName, value: x.sessionName });
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
                totalOfUnits = totalOfUnits + x.numberOfUnits
            } else {
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
                totalOfUnits = totalOfUnits + x.numberOfUnits
                var duplicate = result.find(y => parseInt(y.employeeID) == parseInt(x.employeeID));

                var duplicateName = names.find(y => y === x.sessionName);

                if (!duplicateName) {
                    names.push(x.sessionName);
                    unitNames.push(x.sessionName + 'UN')
                    csvHeaders.push({ label: x.sessionName, value: x.sessionName });
                }

                if (duplicate) {
                    duplicate[sessionName] = checkUndifind(duplicate[sessionName]) + checkUndifind(x.totalAmount);
                    duplicate[sessionName + 'UN'] = checkUndifind(duplicate[sessionName + 'UN']) + checkUndifind(x.numberOfUnits)
                    duplicate.registrationNumber = x.registrationNumber;
                    duplicate.firstName = x.firstName;
                    duplicate.configurationValue = x.configurationValue;
                    duplicate.maxValue = x.maxValue;
                    duplicate.minValue = x.minValue;
                    if (x.fieldName && x.fieldName.trim()) {
                        const trimmedField = x.fieldName.trim();
                        const existingFields = duplicate.fieldName ? duplicate.fieldName.split(', ').map(f => f.trim()) : [];
                        if (!existingFields.includes(trimmedField)) {
                            existingFields.push(trimmedField);
                        }
                        duplicate.fieldName = existingFields.join(', ');
                    }
                    duplicate.borrowedDivision = x.borrowedDivision;
                    duplicate.mandays = x.mandays;

                    const existingReadTime = duplicate[sessionName + ' ReadTime'];
                    if (!existingReadTime || new Date(x.cardReadTime) > new Date(existingReadTime)) {
                        duplicate[sessionName + ' ReadTime'] = x.cardReadTime;
                    }
                    if (!duplicate.assignAt || (x.assignAt && new Date(x.assignAt) > new Date(duplicate.assignAt))) {
                        duplicate.assignAt = x.assignAt;
                    }

                    duplicate.total = checkUndifind(duplicate.total) + checkUndifind(x.totalAmount);
                    duplicate.isAssigned = duplicate.isAssigned || x.isAssigned;
                } else {
                    result.push({
                        [sessionName]: checkUndifind(x.totalAmount),
                        [sessionName + 'UN']: checkUndifind(x.numberOfUnits),
                        employeeID: parseInt(x.employeeID),
                        registrationNumber: x.registrationNumber,
                        firstName: x.firstName,
                        total: checkUndifind(x.totalAmount),
                        configurationValue: x.configurationValue,
                        fieldName: x.fieldName,
                        borrowedDivision: x.borrowedDivision,
                        maxValue: x.maxValue,
                        minValue: x.minValue,
                        isHolidayOrSunday: x.isHolidayOrSunday,
                        [sessionName + ' ReadTime']: x.cardReadTime,
                        mandays: x.mandays,
                        isAssigned: x.isAssigned,
                        assignAt: x.assignAt
                    });
                }
            }
        });
        names.sort((a, b) => a > b ? 1 : -1);
        unitNames.sort((a, b) => a > b ? 1 : -1);

        csvHeaders.push({ label: "Total", value: "total" });
        if (searchData.pluckingType == 'GENERAL') {
            csvHeaders.push({ label: "Mandays", value: "duration" });
            csvHeaders.push({ label: "Cash Kilo", value: "overKilo" });
        }

        var result2 = [];
        let resultUN1 = []
        result.forEach(x => {
            names.forEach(y => {
                if (x[y]) {
                    result2.push({
                        property: y,
                        value: checkUndifind(x[y])
                    });
                }
            });
        });

        result.forEach(x => {
            unitNames.forEach(y => {
                if (x[y]) {
                    resultUN1.push({
                        property: y,
                        value: checkUndifind(x[y])
                    });
                }
            });
        });
        const result3 = result2.reduce((obj, el) => {
            obj[el.property] = (obj[el.property] || 0) + el.value;
            return obj;
        }, {});

        const resultUN2 = resultUN1.reduce((obj, el) => {
            obj[el.property] = (obj[el.property] || 0) + el.value;
            return obj
        }, {})

        const result4 = result.filter(x => x.total >= x.configurationValue);
        const result5 = result.filter(x => x.total < x.configurationValue && x.total >= x.configurationValue / 2);
        const result6 = result.filter(x => x.total < (x.configurationValue / 2));
        let okTot = 0;
        let totMan = 0;
        let totManDays = 0;
        result.forEach(x => {
            if ((parseFloat(x.total) < parseFloat(x.configurationValue) / 2)) {
                //okTot = okTot + parseFloat(x.total);
            }
            else if ((parseFloat(x.total) - parseFloat(x.configurationValue)) < 0) {
                okTot = okTot + (parseFloat(x.total) - parseFloat(x.configurationValue) / 2)
            }
            else {
                okTot = okTot + (parseFloat(x.total) - parseFloat(x.configurationValue));
            }
            totMan = totMan + (parseFloat(x.total) < (parseFloat(x.configurationValue) / 2) ? 0 : (parseFloat(x.total) >= parseFloat(x.configurationValue)) ? 1 : 0.5);
        });

        setSummeryValues({
            ...summeryValues,
            full: result4.length,
            half: result5.length,
            bellow: result6.length,
            allTotal: totalOfAllrecords,
            totMan: totMan,
            okTot: okTot,
            totalOfUnits: totalOfUnits,
            totMandays: totManDays
        });

        setCsvHeaders(csvHeaders);
        setSubNames(names);
        setdata(result);
        setdata1(result);
        setCsvData(result);
        setColName(names);
        setUnitNames(unitNames)

        var resultqqqq = Object.entries(result3);
        let resultun = Object.entries(resultUN2)

        var temlArry = [];
        let temlArry2 = [];

        for (const key in resultqqqq) {
            temlArry.push({
                name: resultqqqq[key][0],
                value: resultqqqq[key][1]
            })
        }
        for (const key in resultun) {
            temlArry2.push({
                name: resultun[key][0],
                value: resultun[key][1]
            })
        }
        temlArry.sort((a, b) => a.name > b.name ? 1 : -1);
        setSummeryData(temlArry);
        setSummaryUnits(temlArry2)
    }

    function checkUndifind(value) {
        if (value === undefined) {
            return 0;
        }
        else {
            return value;
        }
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity.find(x => x.id == searchForm.operationEntityID)?.name,
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            pluckingType: searchForm.pluckingType,
            date: searchForm.date,
            checklistID: searchForm.checklistID == "0" ? "All Checklist Numbers" : searchForm.checklistID
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function onCancelClick() {
        setsearchData({
            ...searchData,
            collectionPointID: "0",
            pluckingType: "0",
            date: new Date().toISOString().split('T')[0]
        });

        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setdata([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    function handleChange1(e) {
        const target = e.target;
        const value = target.value
        setCustomSearch({
            ...customSearch,
            regNumber: value
        });
    }

    async function handleSearch1(data2) {
        if (data == null || data.length == 0) {
            setdata(data1)
        }
        const Default = data.filter(x => x.registrationNumber.toLowerCase().includes(data2.toLowerCase()) || x.firstName.toLowerCase().includes(data2.toLowerCase()))
        if (data2 == '') {
            setdata(data1)
            return;
        }
        setdata(Default)
    }

    async function getChecklistForDropdown() {
        let model = {
            searchDate: searchData.date == "" ? null : searchData.date,
            jobTypeID: searchData.pluckingType == "" ? "" : searchData.pluckingType,
            collectionPointID: searchData.collectionPointID
        }
        if (searchData.date !== "") {
            const result = await service.getChecklistForDropdown(model);
            setChecklist(result);
        }
    }

    const getOverKg = (row) => {
        const total = parseFloat(row.total);
        const maxValue = parseInt(row.maxValue);
        const minValue = parseInt(row.minValue);
        const isHolidayOrSunday = parseInt(row.isHolidayOrSunday);
        let overKg;
        let day;
        let isCashKilo = false;
        let manDay;
        if (isHolidayOrSunday == 1) {
            if (total >= maxValue) {
                overKg = (total - maxValue).toFixed(2);
                manDay = 1.50;
                day = maxValue.toFixed(2);
            } else if (total < maxValue) {
                overKg = Math.floor(total).toFixed(2);
                day = 0.00;
                manDay = 0.00;
                //isCashKilo = true;
            }
        }
        else {

            if (total >= maxValue) {
                overKg = (total - maxValue).toFixed(2);
                day = maxValue.toFixed(2);
                manDay = 1.00;
            } else if (total >= minValue && total <= maxValue) {
                overKg = (0).toFixed(2);
                day = total.toFixed(2);
                manDay = 1.00;
            } else if (total <= minValue && total >= (maxValue / 2)) {
                overKg = Math.floor(total - (maxValue / 2)).toFixed(2);
                day = Math.ceil(maxValue / 2).toFixed(2);
                isCashKilo = true;
                manDay = 0.50;
            } else if (total < (maxValue / 2)) {
                overKg = (total).toFixed(2);
                day = (0).toFixed(2);
                manDay = 0.00;
            } else {
                overKg = (0).toFixed(2);
                day = (0).toFixed(2);
                manDay = 0.00;
            }

        }
        return { overKg, day, isCashKilo, manDay };
    };

    function calculateTotal() {

        const totalOverKg = data.reduce((accumulator, current) => {
            const overKgTotal = parseFloat(getOverKg(current).overKg);
            return accumulator + overKgTotal;
        }, 0);

        const totalDay = data.reduce((accumulator, current) => {
            const dayTotal = parseFloat(getOverKg(current).day);
            return accumulator + dayTotal;
        }, 0);

        const totManDays = data.reduce((accumulator, current) => {
            const dayTotalx = parseFloat(getOverKg(current).manDay);
            return accumulator + dayTotalx;
        }, 0);

        setTotalValues({
            ...totalValues,
            totalOverKg: totalOverKg,
            totalDay: totalDay
        });

        setSummeryValues({
            ...summeryValues,
            totMandays: totManDays
        });
    }
    const newCol = ["Session 1", "Session 2", "Session 3", "Session 4"]
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Plucking Checklist BPL Report - TEA"
                                isButtonEnable={false}
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {/* {generateDropDownMenu(operationEntity)} */}
                                        {/* {generateDropDownMenu(multipleEstates.length == 0 ? operationEntity : multipleEstates)} */}
                                        {(multipleEstates.length === 0 ? operationEntity : multipleEstates)?.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.name}
                                            </MenuItem>
                                        ))
                                        }
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection Point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}

                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="pluckingType">Plucking Type *</InputLabel>
                                    <Select
                                        id="pluckingType"
                                        select
                                        fullWidth
                                        name="pluckingType"
                                        onChange={(e) => handleChange(e)}
                                        value={searchData.pluckingType}>
                                        <MenuItem value="0">--Select Plucking Type--</MenuItem>
                                        <MenuItem value="GENERAL">General</MenuItem>
                                        <MenuItem value="RSM">Outgrower</MenuItem>
                                        <MenuItem value="CASH">Cash</MenuItem>
                                        <MenuItem value="KILO">Kilo</MenuItem>
                                    </Select>
                                    {errors["pluckingType"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["pluckingType"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="searchDate">Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="date"
                                        name="date"
                                        type="date"
                                        inputProps={{ max: new Date().toISOString().split('T')[0] }}
                                        value={searchData.date}
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="checklistID">Checklist Number *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="checklistID"
                                        name="checklistID"
                                        value={searchData.checklistID}
                                        onChange={(e) => handleChangeCheck(e)}>
                                        <MenuItem value="0">--Select Checklist Number--</MenuItem>
                                        {generateDropDownMenu(checklist)}
                                    </Select>
                                    {errors["checklistID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["checklistID"]}</FormHelperText>)}
                                </div>

                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>
                        {hideSearch ? '' :
                            <Box display="flex" flexDirection="row-reverse" p={2} >
                                <TextField
                                    size="small"
                                    style={{ width: '300px' }}
                                    value={customSearch.regNumber}
                                    placeholder="Search"
                                    onChange={(e) => { handleChange1(e) }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        }
                        {data.length != 0 ?
                            <Card>
                                <TableContainer component={Paper}>
                                    <div className="row alternative_cls bg-light  ">
                                        <div className="card-body width1" style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px', marginTop: '20px' }}>
                                        </div>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="left" colSpan={7} style={{ fontWeight: "bold", width: "250px" }}>
                                                        Plucking Check List
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={4} style={{ fontWeight: "bold", width: "250px" }}>
                                                        {searchData.pluckingType === "RSM" ? "Outgrower" : searchData.pluckingType}
                                                    </TableCell>

                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>

                                                    </TableCell>

                                                    <TableCell align="left" colSpan={3} style={{ fontWeight: "bold", width: "250px" }}>
                                                        Initial of Field Officer
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold", width: "250px" }}>

                                                    </TableCell>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                        Norm / Task
                                                    </TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                        Date
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={2} style={{ fontWeight: "bold" }}>
                                                        {searchData.date}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", width: "150px" }}>
                                                        Operation Entity
                                                    </TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                        {selectedSearchValues.operationEntity}
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={10} style={{ fontWeight: "bold" }}>
                                                        Name and Initial of Field Asst.
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Collection Point
                                                    </TableCell>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                        {selectedSearchValues.collectionPoint}
                                                    </TableCell>
                                                    <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>
                                                        No .of Workers at Muster : {data.length}
                                                    </TableCell>

                                                    <TableCell align="left" colSpan={4} style={{ fontWeight: "bold" }}>
                                                        Muster Distributed by :
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>

                                                    </TableCell>
                                                    <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>
                                                        Field Officer :
                                                    </TableCell>

                                                    <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>
                                                        Supervisor
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        E.P.F. No.
                                                    </TableCell>
                                                    <TableCell align="center" colSpan={1} style={{ fontWeight: "bold" }}>
                                                        Name
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Field No.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        1st Wt.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        2nd Wt.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        3rd Wt.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        4th Wt.
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Day
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        OK / CK
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Man Day
                                                    </TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                                        Borrowed Division
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data.map((row, index) => {
                                                    const { overKg, day, isCashKilo } = getOverKg(row);

                                                    return (
                                                        <TableRow
                                                            key={row.registrationNumber}
                                                            style={isCashKilo && searchData.pluckingType == "GENERAL" ? { background: "#C8EDBE" } : {}}
                                                        >
                                                            <TableCell component="th" align="center">
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell align="center" >
                                                                {row.registrationNumber}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.firstName}
                                                                <br />
                                                                {row.assignAt ? (
                                                                    <span style={{ color: 'green' }}>
                                                                        {`(${moment(row.assignAt).format("hh:mm a")})`}
                                                                    </span>
                                                                ) : (
                                                                    searchData.pluckingType === "RSM" ? null : (
                                                                        <span style={{ color: 'red' }}>
                                                                            {"(Not Assigned)"}
                                                                        </span>
                                                                    )
                                                                )}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {row.fieldName}
                                                            </TableCell>
                                                            {/* {
                                                                subNames.map((column) => {
                                                                    const value = row[column];
                                                                    return (
                                                                        <TableCell align='right'>{value == undefined ? ' ' : parseFloat(value).toFixed(2)}</TableCell>
                                                                    );
                                                                })
                                                            } */}
                                                            {newCol.map((roww, index) => {
                                                                const found = row[roww];
                                                                const sessionTimeKey = `${roww} ReadTime`;
                                                                const sessionTime = row[sessionTimeKey];

                                                                return (
                                                                    //<TableCell align="right">{found == undefined ? ' ' : parseFloat(found).toFixed(2)} <br /> {moment(row.cardReadTime).format("hh:mm a")}</TableCell>
                                                                    <TableCell align="right" key={index}>
                                                                        {found !== undefined ? parseFloat(found).toFixed(2) : ' - '}
                                                                        <br />
                                                                        <span style={{ color: 'green' }}>
                                                                            {sessionTime ? `(${moment(sessionTime).format("hh:mm a")})` : ' '}
                                                                        </span>
                                                                    </TableCell>
                                                                )
                                                            })}
                                                            {/* {subNames.length < 1 ? <TableCell align="center">{row[subNames[1]] == undefined ? ' ' : parseFloat(row[subNames[1]]).toFixed(2)}</TableCell> : <TableCell align="center"></TableCell>}
                                                            {subNames.length < 2 ? <TableCell align="center"></TableCell> : ''}
                                                            {subNames.length < 3 ? <TableCell align="center"></TableCell> : ''}
                                                            {subNames.length < 4 ? <TableCell align="center"></TableCell> : ''} */}
                                                            {
                                                                searchData.pluckingType == 'GENERAL' ?
                                                                    // <TableCell align="center">{parseFloat(row.total) < parseFloat(row.configurationValue) / 2
                                                                    //     ? 0
                                                                    //     : (parseFloat(row.total) - parseFloat(row.configurationValue) < 0
                                                                    //         ? (parseFloat(row.total) - parseFloat(row.configurationValue) / 2).toFixed(2)
                                                                    //         : (parseFloat(row.total) - parseFloat(row.configurationValue)).toFixed(2))}</TableCell> 
                                                                    <TableCell align="right">{getOverKg(row).day == 0 ? "0.00" : getOverKg(row).day}</TableCell> :
                                                                    <TableCell align="right"></TableCell>
                                                            }
                                                            {/* {row.total ? <TableCell align="right">{row.total.toFixed(2)}</TableCell> : <TableCell align="right"></TableCell>} */}
                                                            {/* { row.total ? <TableCell align="right">{getOverKg(row).day}</TableCell> : <TableCell align="right"></TableCell> }  */}
                                                            {
                                                                searchData.pluckingType === 'GENERAL' ?
                                                                    (row.total ? <TableCell align="right">{getOverKg(row).overKg}</TableCell> : <TableCell align="right"></TableCell>) :
                                                                    (row.total ? <TableCell align="right">{row.total.toFixed(2)}</TableCell> : <TableCell align="right"></TableCell>)
                                                            }
                                                            {
                                                                searchData.pluckingType === 'GENERAL' ?
                                                                    (< TableCell align="center" >{getOverKg(row).manDay == 0 ? '-' : getOverKg(row).manDay.toFixed(2)}</TableCell>) :
                                                                    (< TableCell align="center" >{"-"}</TableCell>)
                                                            }
                                                            <TableCell align="left">{row.borrowedDivision == null ? '-' : row.borrowedDivision}</TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                    </TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">
                                                        Total
                                                    </TableCell>
                                                    {newCol.map((item) => {
                                                        const found = summeryData.find(x => x.name == item);
                                                        if (found) {
                                                            return (
                                                                <TableCell style={{ fontWeight: "bold" }} align="right">
                                                                    {parseFloat(found.value).toFixed(2)}
                                                                </TableCell>
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                <TableCell style={{ fontWeight: "bold" }} align="right">
                                                                </TableCell>
                                                            )
                                                        }
                                                    })}
                                                    {/* {subNames.length < 1 ? <TableCell align="center"></TableCell> : ''}
                                                    {subNames.length < 2 ? <TableCell align="center"></TableCell> : ''}
                                                    {subNames.length < 3 ? <TableCell align="center"></TableCell> : ''}
                                                    {subNames.length < 4 ? <TableCell align="center"></TableCell> : ''} */}
                                                    {searchData.pluckingType == 'KILO' || searchData.pluckingType == 'RSM' ? <TableCell align="center"></TableCell> : null}
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">{summeryValues != undefined ? parseFloat(totalValues.totalDay).toFixed(2) : ''}</TableCell> :
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">{summeryValues != undefined ? summeryValues.allTotal.toFixed(2) : ''}</TableCell>}
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">
                                                            {parseFloat(totalValues.totalOverKg).toFixed(2)}
                                                        </TableCell> : <TableCell></TableCell>}
                                                    {searchData.pluckingType == 'GENERAL' ?
                                                        <TableCell style={{ fontWeight: "bold" }} align="right">
                                                            {parseFloat(summeryValues.totMandays).toFixed(2)}
                                                        </TableCell> : <TableCell></TableCell>}
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        G.Leaf wt.
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        No. of Bags
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={7} style={{ fontWeight: "bold" }} align="center">
                                                        Checked by Supdt. / Asst. Supdt./ Field Officer
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        1 st
                                                    </TableCell>
                                                    <TableCell>{summeryData.find(x => x.name == "Session 1")?.value.toFixed(2) ?? ''}</TableCell>
                                                    <TableCell>{summaryUnits.find(x => x.name == "Session 1UN")?.value.toFixed(2) ?? ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Plkrs at PM Check
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="center">
                                                        Checked by :
                                                    </TableCell>
                                                    <TableCell colSpan={3} ></TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        2 nd
                                                    </TableCell>
                                                    <TableCell>{summeryData.find(x => x.name == "Session 2")?.value.toFixed(2) ?? ''}</TableCell>
                                                    <TableCell>{summaryUnits.find(x => x.name == "Session 2UN")?.value.toFixed(2) ?? ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Plkrs at AM Check
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">
                                                        Name & Designation
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Time
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Initial
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        3 rd
                                                    </TableCell>
                                                    <TableCell>{summeryData.find(x => x.name == "Session 3")?.value.toFixed(2) ?? ''}</TableCell>
                                                    <TableCell>{summaryUnits.find(x => x.name == "Session 3UN")?.value.toFixed(2) ?? ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        No.of Kanganies AM
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell>{summeryData.find(x => x.name == "Session 4")?.value.toFixed(2) ?? ''}</TableCell>
                                                    <TableCell>{summaryUnits.find(x => x.name == "Session 4UN")?.value.toFixed(2) ?? ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        No.of Kanganies PM
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                </TableRow>
                                                <TableRow >
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        Total
                                                    </TableCell>
                                                    <TableCell>{summeryValues != undefined ? summeryValues.allTotal.toFixed(2) : ''}</TableCell>
                                                    <TableCell>{summeryValues != undefined ? summeryValues.totalOfUnits : ''}</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                                        No.of Sack Labrs
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }} align="center">

                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </div>
                                </TableContainer>
                            </Card>
                            : null}
                    </div>
                    {data.length != 0 ?
                        <div className="pt-2">
                            <ReactToPrint
                                documentTitle={"Plucking Manual Checklist BPL Report - TEA"}
                                trigger={() => <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="PDF"

                                />}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} searchData={selectedSearchValues} contentRowNames={subNames} data={data} totalValues={totalValues}
                                    initialData={colName} summeryValues={summeryValues} summeryData={summeryData} selectedSearchValues={selectedSearchValues} unitNames={unitNames} summaryUnits={summaryUnits}
                                />
                            </div>
                        </div>
                        : null}
                </div>
            </div >
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}



